export default {
  data() {
    return {
      coinName: '积分',
    };
  },
  components: {},
  computed: {
  },
  created() {
    if (this.$route && this.$route.query) {
      const { from } = this.$route.query;
      if (from && from === 'jubaopen_shop_home') {
        this.coinName = '金币';
      } else {
        this.coinName = '积分';
      }
    }
  },
  methods: {
  },
};
